import { DEFAULT_PAGINATION_REQUEST, DEFAULT_PER_PAGE, START_PAGE } from "@/constants/pagination";
import { useSorting } from "@/hooks/useSorting";
import { TApiPagReq, TApiSortsReq } from "@/types/api";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export const usePagination = (): TApiPagReq => {
  const { pathname, search } = useLocation();
  const { sorts } = useSorting();

  const pagination = useMemo(() => {
    const query = new URLSearchParams(location.search);
    const data = { ...DEFAULT_PAGINATION_REQUEST };

    data.page = Number(query.get("page") || START_PAGE);
    data.perPage = Number(query.get("perPage") || DEFAULT_PER_PAGE);
    data.sorts = sorts as TApiSortsReq[];

    return data;
  }, [search, pathname, sorts]);

  return pagination;
};
